import * as z from "zod/v4";

export const getErrorFulfillmentBreakdown = {
  name: "getErrorFulfillmentBreakdown" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    canonicalLocationExternalId: z.string().optional(),
  }),
  output: z.object({
    errors: z.array(z.object({ reason: z.string(), count: z.number() })),
  }),
};
